import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IDataEntryForm } from './../models/data-entry.model';

@Injectable({
  providedIn: 'root'
})
export class FormTemplateDataEntryService {

  constructor(private http: HttpClient) {
  }

  async getFormTemplateAsync(formTemplateName) {
    var template = await this.http.get<IDataEntryForm>("assets/formtemplates/" + formTemplateName + ".json").toPromise();
    return template;
  }

  getFormTemplate(formTemplateName) {
    var template = this.http.get<IDataEntryForm>("assets/formtemplates/" + formTemplateName + ".json");
    return template;
  }
}